import { render, staticRenderFns } from "./ProductOperate.vue?vue&type=template&id=07869e11&scoped=true"
import script from "./ProductOperate.vue?vue&type=script&lang=js"
export * from "./ProductOperate.vue?vue&type=script&lang=js"
import style0 from "./ProductOperate.vue?vue&type=style&index=0&id=07869e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07869e11",
  null
  
)

export default component.exports